import React, { useState, useEffect } from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import ListSubheader from '@mui/material/ListSubheader'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { standardBodyFont } from '../../../irmlib/src/themes'
import { defaultSelect } from '../../../irmlib/src/common'
import { useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'


export const GroupedMenu = (props) => {
  const { label, assetTypes, onSelect, size, selected } = props
  const [selectedValue, setSelectedValue] = useState(selected ?? '')
  const theme = useTheme()
  const { t } = useTranslation()

  // Sync with parent's selected prop if it changes
  useEffect(() => {
    if (selected !== undefined) {
      setSelectedValue(selected)
    }
  }, [selected])

  const renderAssetTypes = () => {
    const menuItems = []
    Object.values(assetTypes).forEach((assetType) => {
      if (assetType.isActive) {
        menuItems.push(
          <ListSubheader key={assetType.name}>{t(`dropdowns.${assetType.name}`)}</ListSubheader>,
          ...renderSubAssetTypes(assetType?.subAssetTypes || assetType?.subWorkflowTypes)
        )
      }
    })
    return menuItems
  }
    
  const renderSubAssetTypes = (subAssetTypes) => {
    return Object.values(subAssetTypes).map((subAssetType) => {
      if (subAssetType.isActive) {
        return (
          <MenuItem key={subAssetType.name} value={subAssetType.name}>
            {t(`dropdowns.${subAssetType.name}`)}
          </MenuItem>
        )
      }
      return null
    })
  }

  const handleSelectChange = (event) => {
    const value = event.target.value
    setSelectedValue(value)
    onSelect(value)
  }

  return (
    <div>
      <FormControl variant="standard" sx={size ? { minWidth: size } : { minWidth: 220 }}>
        <InputLabel htmlFor="grouped-select" style={{ ...standardBodyFont(theme), color: 'rgb(0, 0, 0)' }}>{label}</InputLabel>
        <Select 
          value={selectedValue ?? ''}
          onChange={handleSelectChange}
          id="grouped-select" 
          label="Grouping"
          style={{ marginTop: '13px' }}
          >
          <MenuItem value="">
            <em>{defaultSelect}</em>
          </MenuItem>
          {renderAssetTypes()}
        </Select>
      </FormControl>
    </div>
  )
}

GroupedMenu.propTypes = {
  label: PropTypes.string,
  assetTypes: PropTypes.object,
  onSelect: PropTypes.func,
  size: PropTypes.number,
  selected: PropTypes.string
}